import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerAddressCardComponent } from './customer-address-card.component';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [CustomerAddressCardComponent],
  imports: [
    CommonModule,
    IonicModule,
    PipesModule
  ],
  exports: [CustomerAddressCardComponent],
})
export class CustomerAddressCardModule { }
